export function formatPhone(input: string): string {
  let value = input.replace(/\D/g, '');
  if (value.length > 10) value = value.slice(0, 10);

  if (value.length >= 6) {
    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length >= 3) {
    return `(${value.slice(0, 3)}) ${value.slice(3)}`;
  } else if (value.length > 0) {
    return `(${value}`;
  }
  return '';
}
